import {Box} from "@mui/material"
import React from "react"
import Widget from "../../../Widget"

const SchadenshistorieTableRow = ({row, widget, rowCount}) => {
    const renderWidget = _.cloneDeep(widget)
    if (widget.connections?.origin?.pointer) {
        renderWidget.connections.origin.pointer =
            renderWidget.connections?.origin.pointer.replace("[j]", row.deckungArrayEntry).replace("[i]", row.ereignisArrayEntry)
    }

    return (
        <Box py={1} px={2}
            bgcolor={renderWidget.background && "#ddddff"}
            sx={{
                gridColumn: widget.x + 1 + " /span " + widget.w,
                gridRow: widget.y + rowCount + 1 + " /span " + widget.h,
            }}
        >
            <Widget key={renderWidget.i} widget={renderWidget} inputValue={row[renderWidget.property]} payload={row} />
        </Box>
    )
}

export default SchadenshistorieTableRow
